import './financial-details.scss'
import { useMemo } from 'react'
import { TextInfo } from '../../../../text'
import { LoanTypeEnum } from '../../../../../models/enum/loan-type.enum'
import { LoanTypeCode } from '../../../../../utils/code-converter'
import { ApplicationStep2 } from '../../../../../models/classes/ApplicationStep2.class'
import { Helpers } from '../../../../../utils/helper'

interface FinancialDetailsInterface {
  details: ApplicationStep2
}

const FinancialDetails = ({ ...props }: FinancialDetailsInterface) => {

  const isHDBLoan = useMemo(() => {
    return props.details.current_loan_type === LoanTypeEnum.hdb_loan;
  }, [props.details.current_loan_type])

  return (
    <div className='polymer-financial-details'>
      <TextInfo variant='row' title={`Current Loan Type`} description={LoanTypeCode.find(e => e.code === props.details.current_loan_type)?.description} />
      {isHDBLoan && <TextInfo variant='row' title={`Current Outstanding Loan:`} description={
        <div>
          <p className='m-0 fw-700'>{props.details.current_loan_amount ? Helpers.formatThousandSeparator(props.details.current_loan_amount, "S$ ") : "S$ 0.00"}</p>
          {props.details.current_loan_date && <p className='m-0'>As at {Helpers.formatDate(props.details.current_loan_date)}</p>}
        </div>
      } />}


      <div className='polymer-financial-details__seperator'></div>


      <TextInfo variant='row' title={`New Loan Type`} description={LoanTypeCode.find(e => e.code === props.details.new_loan_type)?.description} />




    </div>
  )
}

export default FinancialDetails